// images
import econetUSDImage from '../../assets/images/econet_logo.jpeg';
import netoneLogo from '../../assets/images/netone.png';
import zesaImage from '../../assets/images/zesa.jpg';

import NyaradzoRechargeImage from '../../assets/images/nyaradzo.jpeg';
import TelOneRechargeImage from '../../assets/images/telone-logo.jpeg';

// icons
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import EdgesensorHighIcon from '@mui/icons-material/EdgesensorHigh';
import EdgesensorLowIcon from '@mui/icons-material/EdgesensorLow';

const zimServices = [
    {
        id: 'airtime',
        avatar: '',
        icon: <PhonelinkRingIcon />,
        name: 'Airtime',
        link: '/recharge/airtime',
        msg: 'Econet, Netone, Telecel Airtime',
        btn: 'Buy Now',
        department: 'Airtime'
    },
    {
        id: 'econet-usd-airtime',
        avatar: econetUSDImage,
        icon: '',
        name: 'Econet USD Airtime',
        msg: 'Econet USD Airtime',
        link: '/recharge/airtime/econet-usd',
        btn: 'Buy Now',
        department: 'Airtime'
    },
    {
        id: 'bundles',
        avatar: '',
        icon: <EdgesensorHighIcon />,
        name: 'Econet Airtime & Bundles',
        link: '/recharge/bundles-direct',
        msg: 'Econet ZWL/USD Airtime & Bundles',
        btn: 'Buy Now',
        department: 'Airtime'
    },
    {
        id: 'netone-bundles',
        avatar: netoneLogo,
        icon: '',
        name: 'Netone Airtime & Bundles',
        link: '/recharge/netone',
        msg: 'Netone USD/ZWL Airtime & Bundles',
        btn: 'Buy Now',
        department: 'Airtime'
    },
    {
        id: 'usd-bundles',
        avatar: econetUSDImage,
        icon: '',
        name: 'Econet USD Bundles',
        msg: 'Econet USD Bundles',
        link: '/recharge/econet/usd-bundles',
        btn: 'Buy Now',
        department: 'Airtime'
    },
    {
        id: 'evd',
        avatar: '',
        icon: <EdgesensorLowIcon />,
        name: 'EVD Bundles',
        link: '/recharge/evd-bundle',
        msg: 'Econet, Netone, Telecel Pins/Scratch cards',
        btn: 'Buy Now',
        department: 'Airtime'
    },

    {
        id: '#5',
        avatar: zesaImage,
        icon: '',
        name: 'ZESA Tokens',
        link: '/recharge/zesa-tokens',
        msg: 'Electricity Tokens',
        btn: 'Buy Now',
        department: 'Utility Bills'
    },
    {
        id: '#6',
        avatar: NyaradzoRechargeImage,
        icon: '',
        name: 'Nyaradzo Insurance',
        link: '/pay/nyaradzo',
        msg: 'Nyaradzo Funeral & Life Assurance',
        btn: 'Pay Now',
        department: 'Insurance'
    },
    {
        id: '#7',
        avatar: TelOneRechargeImage,
        icon: '',
        name: 'TelOne Recharge',
        link: '/recharge/telone',
        msg: 'TelOne Recharge',
        btn: 'Recharge Now',
        department: 'Broadband'
    }
];


export default zimServices;
